import {
  IneligibleReasonGeneral,
  LanguageEvaluationResult,
  OutgoingChannelEvaluationResult,
} from 'lib-shared-types-api';

import {
  CHANNEL_MESSAGES,
  GENERAL_INELIGIBLE_MESSAGES,
  LANGUAGE_MESSAGES,
} from '../constants/evaluationMessages';

/** Gets user-friendly status text for channel-level evaluation results */
export const getChannelStatusText = (
  kind: OutgoingChannelEvaluationResult['kind'],
): string => {
  return CHANNEL_MESSAGES[kind] || 'Unknown status';
};

/** Gets user-friendly status text for language-level evaluation results */
export const getLanguageStatusText = (
  kind: LanguageEvaluationResult['kind'],
): string => {
  return LANGUAGE_MESSAGES[kind] || 'Unknown language status';
};

/** Gets user-friendly text for general ineligible reasons */
export const getGeneralIneligibleText = (
  reason: IneligibleReasonGeneral,
): string => {
  return GENERAL_INELIGIBLE_MESSAGES[reason] || 'Conversation not eligible';
};
